import type { DocumentError } from "@packages/commons";

export const COMPILE_ERROR_MESSAGE =
  "The document could not be checked because something unexpected happened. Refresh the document and try again. If the issue remains, contact support.";

export const wrapTechnicalCompilerError = (_error: unknown): DocumentError => {
  return {
    type: "INTERNAL_ERROR",
    message: COMPILE_ERROR_MESSAGE,
  };
};
